import React from "react";
import { ErrorMessage } from "formik";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { TextField } from "@mui/material";
import { getInputHeight, Size } from "src/utils/formUtils/getInputHeight";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { CalendarPickerView } from "@mui/x-date-pickers";

type Props = {
  label?: string;
  required?: boolean;
  format?: string;
  name?: string;
  value: any;
  onChange: (value: any) => void;
  size?: Size;
  minDate?: string | Date;
  maxDate?: string;
  views?: CalendarPickerView[];
};

const ATMDatePicker = ({
  label,
  name,
  required = false,
  value,
  onChange,
  format = "DD MMM yyyy",
  size = "small",
  minDate,
  maxDate,
  // views = ['day', 'month' , 'year'] ]'
  views = ["day"],
}: Props) => {
  return (
    <div className="relative">
      {label && (
        <label className="text-slate-700 font-medium">
          {" "}
          {label} {required && <span className="text-red-500"> * </span>}{" "}
        </label>
      )}

      <div className={` ${getInputHeight(size)} flex items-center`}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DesktopDatePicker
            views={views}
            inputFormat={format}
            value={value}
            onChange={onChange}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                fullWidth
                className="bg-white"
              />
            )}
            minDate={minDate}
            maxDate={maxDate}
            disableMaskedInput
          />
        </LocalizationProvider>
      </div>

      {name && (
        <ErrorMessage name={name}>
          {(errMsg) => (
            <p className="font-poppins absolute text-[14px] text-start mt-0 text-red-500">
              {" "}
              {errMsg}{" "}
            </p>
          )}
        </ErrorMessage>
      )}
    </div>
  );
};

export default ATMDatePicker;
